export default "/images/framework/CurrentPuzzlechaseRankingEng.b47f6389.svg?b47f6389";